<template>
	<div>
		<div ref="select" v-if="isMobile === false" class="form-group" :class="classes" v-click-outside="close">
			<label v-if="labelText != ''" @click="close">
				{{ labelText }}
				<span v-if="labelOption != ''">{{ labelOption }}</span>
			</label>
			<div class="clear-fix"></div>

			<div ref     ="btn"
				 tabindex="1"
				 class   ="form-control select dropdown-toggle"
				 :id     ="id"
				 :class  ="{
					'input-lg': inputLarge,
					'input-sm': inputSmall,
					error: this.hasError
					}"
				 :disabled="disabled"
				 :readonly="readonly"
				 @keydown.esc.stop.prevent  ="close"
				 @keydown.space.stop.prevent="toggle"
				 @keydown.enter.stop.prevent="toggle"
				 @keydown.stop="handleKeypress"
				 @focus="open">

				<span
					@click="transferFocusUp"
					class="btn-content"
					:class    ="{
						'hidden': isMobile
					}"
					v-html="loading ? loading : showPlaceholder || selected"></span>
				<span @click="transferFocusUp" class="caret"></span>
			</div>

			<ul class="dropdown-menu"
				tabindex="1"
				:class="{
					'dropdown-lg': inputLarge,
					'input-sm': inputSmall
				}"
				ref="options">
				<template v-if="filteredList.length">
					<li
						v-for="option in optionListItems"
						:id="option[optionsValue]"
						:value="option[optionsValue]"
						:class="{ 'disabled-item': option['disabled'] === true }">
						<a
							@mousedown.prevent="select(option[optionsValue], option['disabled'])"
							:class="{ 'highlight': highlightedOption === option[optionsValue] }">
							<slot name="option" v-bind:option="option">
								<span>{{ dontLocalize ? option[optionsLabel] : $t(stringSelector + '.' + option[optionsLabel]) }}</span>
							</slot>
						</a>
					</li>
				</template>
			</ul>
		</div>

		<div v-if="isMobile" class="form-group mobile" :class="{ disabled: this.disabled }">
			<select
				ref       ="sel"
				v-model   ="val"
				class="form-control"
				:class    ="{
					'hidden': !isMobile,
					error: this.hasError
					}"
				:name    ="name"
				:id      ="id"
				:required="required"
				:readonly="readonly"
				:disabled="disabled">
				<option
					v-for="option in optionListItems"
					:value="option[optionsValue]"
					:disabled="option['disabled'] === true">
					{{ dontLocalize ? option[optionsLabel] : $t(stringSelector + '.' + option[optionsLabel]) }}
				</option>
			</select>

			<span
				class="btn-content placeholder"
				:class    ="{
					'hidden': isMobile && selected
				}"
				v-html="loading ? loading : showPlaceholder || selected">
			</span>
			<span class="caret"></span>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import clickOutside from '../../utils/click-outside';

const timeout = {};

export default {
	name: 'formSelect',
	description: 'Support custom style and embedded mobile slelect option',
	directives: {
		clickOutside
	},
	props: {
		hasError: {
			type: Boolean,
			default: false,
			note: 'Check error state'
		},
		closeOnSelect: {
			type: Boolean,
			default: false,
			note: 'Set the option close behavior'
		},
		disabled: {
			type: Boolean,
			default: false,
			note: 'Disable when it needed'
		},
		name: {
			type: String,
			default: null,
			note: 'Set attribute name'
		},
		id: {
			type: String,
			default: null,
			note: 'Set element id '
		},
		options: {
			type: Array,
			default() {
				return [];
			},
			note: 'Selectable option list'
		},
		optionsLabel: {
			type: String,
			default: 'label',
			note: 'Options label text'
		},
		optionsValue: {
			type: String,
			default: 'value',
			note: 'Options value'
		},
		selectedOptionLabel: {
			type: String,
			default: '',
			note: 'Selected option label text'
		},
		parent: {
			default: true
		},
		placeHolder: {
			type: String,
			default: null,
			note: 'Place holder text'
		},
		readonly: {
			type: Boolean,
			default: null,
			note: 'Change read only'
		},
		required: {
			type: Boolean,
			default: null,
			note: 'Set input requried'
		},
		value: null,
		inputLarge: {
			type: Boolean,
			default: false,
			note: 'Change input element size to large'
		},
		inputSmall: {
			type: Boolean,
			default: false,
			note: 'Change input element size to small'
		},
		labelText: {
			type: String,
			default: null,
			note: 'From label text'
		},
		labelOption: {
			type: String,
			default: null,
			note: 'Additional text next to label text'
		},
		stringSelector: {
			type: String,
			default: null,
			note: 'Need to be assigned string selector to get localized text'
		},
		orderByLoco: {
			type: Boolean,
			default: false,
			note: 'Pption list ordering option'
		},
		dontLocalize: {
			type: Boolean,
			default: false,
			note: 'If it does not need localize '
		},
		filterable: {
			type: Boolean,
			default: false,
			note: 'Options filtering option'
		}
	},
	data() {
		return {
			textFilter: '',
			list: [],
			loading: null,
			show: false,
			val: null,
			isMobile: this.$store.state.isMobile,
			highlightedOption: null
		};
	},
	computed: {
		classes() {
			return [
				{
					open: this.show,
					disabled: this.disabled
				},
				this.class,
				this.elementNameClass,
			];
		},
		elementNameClass() {
			if (this.isLi)
				return 'dropdown';
			if (this.inInput)
				return 'input-group-btn';
			return 'btn-group';
		},
		inInput() { return this.$parent._input; },
		isLi() {
			return
				this.$parent._navbar ||
				this.$parent.menu ||
				this.$parent._tabset;
		},
		selected() {
			if (this.filteredList.length === 0) {
				const currentIndex = this.list
					.map(({ label, value }) => value)
					.indexOf(this.highlightedOption);
				if (currentIndex === -1) {
					return this.placeHolder;
				}
				const currentLabel = this.list[currentIndex].label;
				if (this.dontLocalize) {
					return currentLabel;
				} else {
					return this.$t(`${this.stringSelector}.${currentLabel}`);
				}
			}
			const sel = this.values.map(val =>
				(
					this.filteredList.find(
						o => o[this.optionsValue] === val
					) || {}
				)[this.selectedOptionLabel && !this.isMobile ? this.selectedOptionLabel : this.optionsLabel]).filter(val => val !== undefined);
			this.$emit('selected', sel);
			if (this.dontLocalize) {
				return sel[0];
			} else {
				if (sel[0]) {
					return this.$t(this.stringSelector + '.' + sel.join(', '));
				} else {
					return this.placeholder
				}
			}
		},
		showPlaceholder() {
			return (this.values.length === 0) ? (this.placeHolder) : null;
		},
		values() {
			return this.val instanceof Array ? this.val : ~[null, undefined].indexOf(this.val) ? [] : [this.val];
		},
		optionListItems() {
			if (this.orderByLoco) {
				return this.inLocoOrder;
			}
			return this.filteredList;
		},
		inLocoOrder() {
			const sorted = this.filteredList.slice();
			sorted.sort((a,b) => {
				return this.$t(`${this.stringSelector}.${a.label}`)
					.localeCompare(this.$t(`${this.stringSelector}.${b.label}`));
			});
			return sorted;
		},
		filteredList() {
			if (!this.filterable) {
				return this.list;
			}
			const filtered = this.list.filter(
				({ label, value }) =>
					(this.dontLocalize ? label : this.$t(`${this.stringSelector}.${label}`))
						.toLowerCase()
						.indexOf(this.textFilter.toLowerCase()) === 0
			);
			return filtered;
		},
	},
	watch: {
		options(modifiedOptions) {
			this.setOptions(modifiedOptions);
		},
		value(val, old) {
			if (val !== old) { this.val = val; }
		},
		val(val, old) {
			if (val === undefined) { this.val = val = null; }
			if (val !== old) {
				this.$emit('change', val);
				this.$emit('input', val);
				this.highlightedOption = val;
			}
		}
	},
	methods: {
		transferFocusUp() {
			const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
			// true on IE11; false on Edge and other IEs/browsers.
			if (isIE11) {
				this.$refs.btn.focus();
			}
		},
		select(v, disabled) {
			if(disabled) {
				return;
			}
			this.val = v;
			this.close();
		},
		scrollSelectionIntoView() {
			this.$nextTick(() => document.getElementById(this.val).scrollIntoView({inline: "nearest", behavior: "smooth"}));
		},
		selectWithoutToggle(v) {
			this.val = v;
			this.highlightedOption = v;
			this.scrollSelectionIntoView();
		},
		selectNextWithoutToggle() {
			if (this.optionListItems.length === 0) {
				return;
			}
			if (this.highlightedOption === null) {
				this.selectWithoutToggle(this.optionListItems[0].value);
			} else {
				const prevIndex = this.optionListItems
					.map(({ label, value }) => value)
					.indexOf(this.highlightedOption);
				if (prevIndex === -1) {
					return;
				}
				if (prevIndex + 1 < this.optionListItems.length) {
					this.selectWithoutToggle(this.optionListItems[prevIndex + 1].value);
				}
			}
		},
		selectPrevWithoutToggle() {
			if (this.optionListItems.length === 0) {
				return;
			}
			if (this.highlightedOption === null) {
				this.selectWithoutToggle(this.optionListItems[this.optionListItems.length - 1].value);
			} else {
				const prevIndex = this.optionListItems
					.map(({ label, value }) => value)
					.indexOf(this.highlightedOption);
				if (prevIndex === -1) {
					return;
				}
				if (prevIndex - 1 >= 0) {
					this.selectWithoutToggle(this.optionListItems[prevIndex - 1].value);
				}
			}
		},
		setOptions(options) {
			this.list = options
				.filter(el => el instanceof Object)
				.map(el => ({ ...el }));
			this.$emit('options', this.list);
		},
		close() {
			this.toggle(false);
		},
		open() {
			this.toggle(true);
		},
		toggle(openOrClosed) {
			if (this.disabled) return;
			this.show = (typeof openOrClosed === 'boolean') ? openOrClosed : !this.show;
			if (!this.show) {
				this.$refs.btn.blur();
				this.clearFilter();
				this.$emit('closed');
			} else {
				this.$emit('open');
			}
		},
		handleKeypress(event) {
			const key = event.key;
			if (key >= 'a' && key <= 'z' || key >= '0' && key <= '9' || key === '.') {
				this.textFilter = `${this.textFilter}${key}`;
				if (this.filteredList[0]) {
					this.selectWithoutToggle(this.filteredList[0][this.optionsValue]);
				}
			} else if (key === 'Backspace') {
				this.textFilter = this.textFilter.slice(0, -1);
				if (this.filteredList[0]) {
					this.selectWithoutToggle(this.filteredList[0][this.optionsValue]);
				}
			} else if (key === 'Tab') {
				this.close();
				this.$emit('keydown', {key: 'Tab'});
			} else if (key === 'ArrowUp') {
				this.selectPrevWithoutToggle();
				event.preventDefault();
			} else if (key === 'ArrowDown') {
				this.selectNextWithoutToggle();
				event.preventDefault();
			}
		},
		clearFilter() {
			this.textFilter = '';
		}
	},
	created() {
		this.setOptions(this.options);
		this.val = this.value;
		if (this.val === undefined || !this.parent) {
			this.val = null;
		}
		const parent = this.$parent;
	},
};
</script>

<style scoped lang="less">
	@text-highlight: #0078ff;
	.error {
		border-color: #e63f57 !important;
	}
	.form-group {
		&.mobile {
			height: 50px;
			margin-top: 20px;
			position: relative;
			.placeholder {
				padding: 0;
				width: auto;
			}
			.caret {
				position: absolute;
				top: 22px;
				right: 15px;
			}
		}
	}
	.btn-group {
		display: block;
		cursor: pointer;
		label {
			width: 100%;
			padding-right: 0;
			span {
				color: @text-highlight;
				font-weight: bold;
				float: right;
			}
		}
		.caret {
			position: absolute;
			right: 20px;
			top: 50px;
		}
		.input-sm {
			.caret {
				top: 34px;
			}
		}
	}
	.btn-content {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: block;
		padding-right: 15px;
		line-height: 1.2em;
	}
	.hidden {
		border: 0;
		clip: rect(0 0 0 0);
		height: 1px;
		margin: -1px;
		overflow: hidden;
		padding: 0;
		position: absolute;
		width: 1px;
	}
	.dropdown-menu {
		max-height: 400px;
		margin-top: -2px;
		width: 100%;
		border: 2px solid #262626;
		overflow: auto;

		&::-webkit-scrollbar {
			width: 8px;
		}

		&::-webkit-scrollbar-track {
			background: #c7c7c7;
		}

		&::-webkit-scrollbar-thumb {
			background: #737373;
			border-radius: 1px;
		}

		li {
			a {
				cursor: pointer;
				padding-top: 15px;
				padding-bottom: 15px;
				white-space: normal;
				&:hover {
					color: #fff;
					background-color: @text-highlight;
				}
				&.highlight {
					color: #fff;
					background-color: @text-highlight;
				}
			}
			&.disabled-item {
				cursor: not-allowed;
				opacity: 0.6;
				a {
					cursor: not-allowed;
				}
			}
		}
		&.dropdown-lg {
			li {
				a {
					padding: 24px 20px;
				}
			}
		}
	}
	.placeholder {
		position: relative;
		color: #262626;
		padding: 0 19px;
		width: 100%;
		top: -36px;
		display: inline-block;
	}

	.murk {
		.form-group {
			position: relative;
		}
		.select {
			font-size: 14px;
		}
		.dropdown-menu {
			border: 1px solid #737373;
			a {
				font-size: 13px;
				line-height: 1.3em;
				padding: 10px !important;
			}
		}
		.placeholder {
			position: absolute;
			font-size: 14px;
			color: #737373;
			left: 19px;
			top: 18px;
			font-weight: normal;
		}
	}
</style>

